export default {
  name: "expired-order-card",
  components: {},
  props: [],
  data() {
    return {
      dialog: false
    };
  },
  computed: {},
  mounted() {},
  methods: {
    handleDialog() {
      this.$emit("confirmReorder", false);
      this.dialog = true;
    }
  }
};
